export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/5ba84b7c5997e2a9223c26a23a6fa17e.svg";